import antdJaJP from 'antd/es/locale/ar_EG';
import axios from "axios";
import { env } from 'configs/EnvironmentConfig';

const fetchMessages = async () => {
    const response = await axios.get(env.IMG_SRC + '/locales/db_DB.json'); // Replace with your URL
    if (response.statusText !== 'OK') {
        throw new Error(`Failed to load translations: ${response.statusText}`);
    }
    return await response.data;
};
const DBLang = {
    antd: antdJaJP,
    locale: 'db',
    fetchMessages
};
export default DBLang;